<template>
  <div>
    <!-- Loader tant que les données ne sont pas prêtes -->
    <div v-if="loading" class="p-4 has-text-centered">
      <i class="fas fa-spinner fa-spin"></i> Chargement des modèles et assistants...
    </div>

    <!-- Le contenu normal une fois que tout est chargé -->
    <div v-else>
      <div class="columns is-multiline">
        <div class="column content_area is-3" style="padding-bottom: 0px; overflow-y: scroll"
             :style="{height: pad_height}">
          <div class="columns is-multiline" v-if="!simulation_mode">
            <div class="column content_area is-12">
              <div class="block">
                <button class="btn btn-primary" :class="{ 'is-clicked': assistant_creation_mode }"
                        @click="detailed_assistant=default_assistant; assistant_creation_mode=true; assistant_detail_mode=false;selected_assistants_uids_list=[];">
                  Créer un assistant
                </button>
              </div>
              <div class="block"><input class="form-control" type="text" v-model="searchQuery"
                                        placeholder="Rechercher un assistant"/></div>
            </div>
            <div v-if="fetching_assistants">
              <h5>
                <div class="icon"><i class="fas fa-spinner fa-spin"></i></div>
                <span>Chargement des assistants...</span>
              </h5>
            </div>
            <div v-else="v-else">
              <div class="column content_area is-12" v-if="filteredAssistants" v-for="assistant in filteredAssistants"
                   :key="assistant.name">
                <div class="card" :class="getAssistantCardClass(assistant)"
                     v-if="assistant.step_set && assistant.step_set.length &gt; 0"
                     @click="select_assistant(assistant.uid)" style="border-radius: 4px; cursor: pointer !important;">
                  <div class="card-content" style="padding: 0.75em;">
                    <div class="level">
                      <div class="level-left">
                        <h5></h5><strong>{{ assistant.name }}</strong>
                      </div>
                      <div class="level-right"><label class="checkbox"></label><input class="form-check-input"
                                                                                      type="checkbox"
                                                                                      @click="assistant_multi_select($event, assistant.uid)"
                                                                                      v-model="assistant.selected"/>
                      </div>
                    </div>
                    <div class="tags"><span class="tag" :class="getAssistantCardTagClass(assistant)">ELO:&nbsp;<strong
                        v-if="assistant.elo_score">{{ assistant.elo_score }}</strong><strong v-else="v-else">pas de parties</strong>
                    </span>
                      <span class="tag" v-if="assistant.step_set && assistant.step_set.length > 0">
                        {{ assistant.step_set[0].llm_name }}
                      </span>
                      <span
                          class="tag">T° {{ assistant.step_set[0].temperature }}</span><span class="tag"
                                                                                             v-if="assistant.created_by">créé par: {{
                          assistant.created_by.username
                        }}</span><span class="tag" v-else="v-else">créé par Logos</span><span class="tag is-warning"
                                                                                              v-if="assistant.is_affected === false">non affecté</span><span
                          class="tag is-danger" v-if="assistant.is_active === false">inactif</span></div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="columns is-multiline" v-if="simulation_mode">
            <div class="column content_area is-12">
              <div class="block">
                <div class="btn-group">
                  <button class="btn btn-primary" :class="{ 'is-clicked': show_select_review }"
                          @click="show_select_review = true">Choisir un avis
                  </button>
                  <button class="btn btn-outline-primary" @click="toggle_simulation_mode">Fermer la simu.</button>
                </div>
              </div>
              <div class="block" v-if="current_simulation_data.text">
                <div class="box p-2 content">
                  <div class="block">
                    <h5 style="cursor: pointer !important;" @click="toggle_review_simulation">Avis
                      <div class="icon"><i class="fas fa-eye"></i></div>
                    </h5>
                  </div>
                  <div v-if="show_review_simulation">
                    <div class="block"><textarea class="textarea" v-model="current_simulation_data.text"
                                                 style="padding-bottom: 0px;" :disabled="true" rows="15"></textarea>
                    </div>
                    <div class="block">
                      <div class="p-2 content" v-if="current_simulation_data.answer">
                        <h5>Réponse</h5><textarea class="textarea" v-model="current_simulation_data.answer"
                                                  style="padding-bottom: 0px;" :disabled="true"></textarea>
                      </div>
                      <div class="p-2 content">
                        <h6>Pas de réponse des consultants</h6>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="block">
                  <button class="btn btn-primary" @click="launch_simulation"
                          :disabled="current_simulation_data.review_uid && current_simulation_data.review_uid.length == 0">
                    Générer
                  </button>
                </div>
                <div class="block p-0 content"
                     v-if="current_simulation_data.assistants_list && current_simulation_data.assistants_list.length > 0 && (current_simulation_data.assistants_list[0].is_loading || current_simulation_data.assistants_list[0].has_been_generated)">
                  <div v-if="current_simulation_data.assistants_list[0].is_loading">
                    <div class="icon"><i class="fas fa-spinner fa-spin"></i></div>
                  </div>
                  <div v-else="v-else">
                    <div class="block" v-if="current_simulation_data.assistants_list[0].simulation_error">
                      <div class="block content">
                        <p>Il y a eu une erreur lors de la génération de la réponse. Ci-dessous le texte de
                          l'erreur.</p>
                        <textarea class="textarea">{{assistant.simulation_error.bodyText}}</textarea><textarea
                          class="textarea">{{assistant.simulation_error.statusText}}</textarea>
                      </div>
                    </div>
                    <div class="block" v-else="v-else">
                      <div class="box p-2 content is-clickable"
                           v-for="(step, index) in current_simulation_data.assistants_list[0].steps_simulations">
                        <div class="block">
                          <h6 style="cursor: pointer !important;" @click="toggle_step_simulation(index)">Step
                            {{ index + 1 }}
                            <div class="icon"><i class="fas fa-eye"></i></div>
                          </h6>
                        </div>
                        <div class="block" v-if="step.simulation_open">
                          <div class="block">
                            <h6 style="cursor: pointer !important;" @click="toggle_step_prompt_simulation(index)">Prompt
                              final
                              <div class="icon"><i class="fas fa-eye"></i></div>
                            </h6>
                            <textarea class="textarea" v-if="step.simulation_prompt_open" v-model="step.prompt"
                                      style="padding-bottom: 0px;" :disabled="true" rows="10"></textarea>
                          </div>
                          <div class="block">
                            <h6>Réponse générée</h6><textarea class="textarea" v-model="step.answer"
                                                              style="padding-bottom: 0px;" :disabled="true"
                                                              rows="10"></textarea>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="block content" v-else="v-else">
                <h5>Veuillez choisir un avis</h5>
              </div>
            </div>
          </div>
        </div>
        <div class="column is-9" v-if="(assistant_creation_mode | assistant_detail_mode)">
          <div class="columns">
            <div class="column is-3 content_area" style="min-width: 320px;">
              <div class="columns is-multiline is-centered">
                <div class="column is-12"><input class="form-control" type="text" v-model="detailed_assistant.name"
                                                 placeholder="Donnez un nom à votre assistant"/><span class="error"
                                                                                                      v-if="errors.name">{{
                    errors.name
                  }}</span></div>
                <div class="column is-12" v-if="assistant_detail_mode">
                  <div class="btn-group">
                    <button class="btn btn-outline-primary" @click="duplicate_current()">Dupliquer</button>
                    <button class="btn btn-outline-primary" @click="show_affect_modal = true">Affecter</button>
                    <button class="btn btn-outline-primary" @click="toggle_simulation_mode"
                            :class="{'is-clicked': simulation_mode}">Simuler
                    </button>
                  </div>
                </div>
                <div class="column is-12">
                  <div class="box form-check form-switch"><input class="form-check-input" id="switchExample"
                                                                 style="height: 24px; width: 50px; margin: 0;"
                                                                 type="checkbox" name="switchExample"
                                                                 v-model="detailed_assistant.is_active"/><label
                      class="form-check-label ms-2" for="switchExample"
                      style="width: 10em">{{ detailed_assistant.is_active ? 'Activé' : 'Inactif' }}</label></div>
                </div>
                <div class="column is-12">
                  <div class="box content">
                    <h5>Indicateurs</h5>

                    <p v-if="detailed_assistant && detailed_assistant.step_set && detailed_assistant.step_set[detailed_assistant.current_open_step_index]">
                      Nombre de token max (input + output):
                      <strong>
                        {{
                          (detailed_assistant.step_set[detailed_assistant.current_open_step_index].max_input_tokens +
                              detailed_assistant.step_set[detailed_assistant.current_open_step_index].max_output_tokens)
                              .toString()
                              .replace(/\B(?=(\d{3})+(?!\d))/g, ' ')
                        }}
                      </strong>
                    </p>

                    <p v-if="detailed_assistant && detailed_assistant.step_set && detailed_assistant.step_set[detailed_assistant.current_open_step_index]">
                      Nombre max de token input :
                      <strong>
                        {{
                          detailed_assistant.step_set[detailed_assistant.current_open_step_index].max_input_tokens
                              .toString()
                              .replace(/\B(?=(\d{3})+(?!\d))/g, ' ')
                        }}
                      </strong>
                    </p>

                    <p v-if="detailed_assistant && detailed_assistant.step_set && detailed_assistant.step_set[detailed_assistant.current_open_step_index]">
                      Nombre max de token output :
                      <strong>
                        {{
                          detailed_assistant.step_set[detailed_assistant.current_open_step_index].max_output_tokens
                              .toString()
                              .replace(/\B(?=(\d{3})+(?!\d))/g, ' ')
                        }}
                      </strong>
                    </p>

                    <p v-if="detailed_assistant && detailed_assistant.step_set && detailed_assistant.step_set[detailed_assistant.current_open_step_index]">
                      Coût par million de token en Input :
                      <strong>
                        {{
                          (detailed_assistant.step_set[detailed_assistant.current_open_step_index].input_cost_per_token * 1e6).toFixed(2)
                        }}€
                      </strong>
                    </p>

                    <p v-if="detailed_assistant && detailed_assistant.step_set && detailed_assistant.step_set[detailed_assistant.current_open_step_index]">
                      Coût par million de token en Output :
                      <strong>
                        {{
                          (detailed_assistant.step_set[detailed_assistant.current_open_step_index].output_cost_per_token * 1e6).toFixed(2)
                        }}€
                      </strong>
                    </p>
                  </div>
                </div>
                <div class="column is-12">
                  <div class="box content">
                    <h5>Spécialisation</h5>
                    <div class="field">
                      <h6>Sentiment</h6>
                      <div class="control">
                        <div class="is-fullwidth"><select class="form-select"
                                                          v-model="detailed_assistant.specialist_sentiment">
                          <option :value="'null'">Aucun</option>
                          <option v-for="sentiment in ['positif', 'negatif']" :key="sentiment" :value="sentiment">
                            {{ sentiment }}
                          </option>
                        </select></div>
                      </div>
                      <span class="error" v-if="errors.specialist_sentiment">{{ errors.specialist_sentiment }}</span>
                    </div>
                    <div class="field">
                      <h6>Plateforme</h6>
                      <div class="control">
                        <div class="is-fullwidth"><select class="form-select"
                                                          v-model="detailed_assistant.specialist_platform_id">
                          <option :value="'null'">Aucune</option>
                          <option v-for="plateforme in platforms_list" :key="plateforme.uid" :value="plateforme.uid">
                            {{ plateforme.name }}
                          </option>
                        </select></div>
                      </div>
                      <span class="error" v-if="errors.specialist_platform_id">{{
                          errors.specialist_platform_id
                        }}</span>
                    </div>
                    <div class="field">
                      <h6>Tags</h6>
                      <div class="control">
                        <div class="is-fullwidth"><select class="form-select" multiple
                                                          v-model="detailed_assistant.tags">
                          <option v-for="tag in tags_set" :key="tag.id" :value="tag">
                            {{ tag.name }}
                          </option>
                        </select></div>
                      </div>
                    </div>
                  </div>
                </div>
                <br/>
                <div class="column is-12">
                  <div class="block"><span class="tags"><span class="tag is-warning"
                                                              v-show="!detailed_assistant.is_affected">non affecté</span><span
                      class="tag is-danger" v-show="!detailed_assistant.is_active">inactif</span></span></div>
                  <div class="block">
                    <button class="btn btn-primary" @click="save_assistant">
                      {{ assistant_detail_mode ? "Enregistrer" : "Créer l'assistant" }}
                    </button>
                  </div>
                </div>
              </div>
            </div>
            <div class="column is-9 content_area">
              <div class="block">
                <div class="box p-3 step-section" v-for="(step, index) in detailed_assistant.step_set" :key="index">
                  <div class="block content">
                    <h4 style="cursor: pointer !important;" @click="toggle_step_settings(index)">Step {{ index + 1 }}
                      <div class="icon"><i class="fas fa-eye"></i></div>
                    </h4>
                  </div>
                  <div class="block content" v-if="step.open">
                    <div class="columns p-0">
                      <div class="column is-7 content_area">
                        <div class="block p-0">
                          <div class="block content p-0">
                            <h5>Prompt</h5>
                          </div>
                          <div class="block p-0"><textarea class="textarea" v-model="step.prompt" placeholder="Prompt"
                                                           style="padding-bottom: 0px;" :style="{height: pad_height}"
                                                           :disabled="detailed_assistant.is_affected"></textarea><span
                              class="error" v-if="errors.prompt">{{ errors.prompt }}</span></div>
                        </div>
                      </div>
                      <div class="column is-5 content_area">
                        <div class="block p-2">
                          <div class="block content">
                            <h5>Paramètres du modèle</h5>
                          </div>
                          <div class="block">
                            <div class="field"><label class="label">Model</label>
                              <div class="control">
                                <select class="form-select"
                                        :key="step.llm_name"
                                        v-model="step.llm_name"
                                        @change="llm_selected($event)"
                                        :disabled="detailed_assistant.is_affected">

                                  <!-- Aucun modèle -->
                                  <option v-if="available_llms && available_llms.length === 0" disabled value="">
                                    Aucun modèle disponible
                                  </option>

                                  <!-- Sélectionner -->
                                  <option v-else value="" disabled>
                                    Sélectionner un modèle
                                  </option>

                                  <!-- Modèles disponibles -->
                                  <option v-for="model in available_llms"
                                          :key="model.name"
                                          :value="model.name">
                                    {{ model.name }} | {{ model.litellm_provider }}
                                  </option>

                                  <!-- Modèle supprimé -->
                                  <option
                                      v-if="step.llm_name && available_llms && !available_llms.some(m => m.name === step.llm_name)"
                                      disabled
                                      :value="step.llm_name">
                                    {{ step.llm_name }} (modèle supprimé)
                                  </option>
                                </select>
                              </div>

                              <span class="error" v-if="errors.llm_name">{{ errors.llm_name }}</span>
                            </div>
                            <div class="field"><label class="label">Température</label>
                              <div class="control"><input class="form-control" type="number" step="0.01" min="0" max="2"
                                                          v-model.number="step.temperature" placeholder="Température"
                                                          :disabled="detailed_assistant.is_affected"/></div>
                            </div>
                            <div class="field"><label class="label">Nombre max de token en réponse</label>
                              <div class="control"><input class="form-control" type="number"
                                                          v-model="step.max_output_tokens" placeholder="Max Token"
                                                          :disabled="detailed_assistant.is_affected"/></div>
                              <span class="error" v-if="errors.max_tokens">{{ errors.max_tokens }}</span>
                            </div>
                            <div class="field"><label class="label">Nombre max de token du prompt</label>
                              <div class="control"><input class="form-control" type="number"
                                                          v-model="step.max_input_tokens" placeholder="Max Token Prompt"
                                                          :disabled="detailed_assistant.is_affected"/></div>
                              <span class="error" v-if="errors.max_tokens">{{ errors.max_tokens }}</span>
                            </div>
                          </div>
                          <div class="block">
                            <div class="form-check"><input class="form-check-input" type="checkbox"
                                                           v-model="step.search_examples"
                                                           :disabled="detailed_assistant.is_affected"/><label
                                class="form-check-label">Recherche d'exemples</label></div>
                            <div v-if="step.search_examples">
                              <div class="field"><label class="label">Options</label></div>
                              <div class="field">
                                <div class="form-check form-check-inline"><input class="form-check-input" type="radio"
                                                                                 v-model="step.example_choice_strategy"
                                                                                 value="random"
                                                                                 :disabled="detailed_assistant.is_affected"/><label
                                    class="form-check-label">Aléatoire</label></div>
                                <div class="form-check form-check-inline"><input class="form-check-input" type="radio"
                                                                                 v-model="step.example_choice_strategy"
                                                                                 value="semantic_search"
                                                                                 :disabled="detailed_assistant.is_affected"/><label
                                    class="form-check-label">Sémantique</label></div>
                              </div>
                              <div class="field">
                                <div class="form-check form-check-inline"><input class="form-check-input" type="radio"
                                                                                 v-model="step.example_selection_strategy"
                                                                                 value="all"
                                                                                 :disabled="detailed_assistant.is_affected"/><label
                                    class="form-check-label">Tous</label></div>
                                <div class="form-check form-check-inline"><input class="form-check-input" type="radio"
                                                                                 v-model="step.example_selection_strategy"
                                                                                 value="pre_selection"
                                                                                 :disabled="detailed_assistant.is_affected"/><label
                                    class="form-check-label">Pré-sélection</label></div>
                              </div>
                              <div class="field">
                                <div class="form-check form-check-inline"><input class="form-check-input" type="radio"
                                                                                 v-model="step.example_fill_strategy"
                                                                                 value="fill_context"
                                                                                 :disabled="detailed_assistant.is_affected"/><label
                                    class="form-check-label">Remplir le contexte</label></div>
                                <div class="form-check form-check-inline"><input class="form-check-input" type="radio"
                                                                                 v-model="step.example_fill_strategy"
                                                                                 value="fixed_n"
                                                                                 :disabled="detailed_assistant.is_affected"/><label
                                    class="form-check-label">N exemples</label></div>
                              </div>
                              <div class="field" v-if="step.example_fill_strategy === 'fixed_n'"><label class="label">Nombre
                                d'exemples</label>
                                <div class="control"><input class="form-control" type="number"
                                                            v-model="step.example_fixed_n"
                                                            placeholder="Nombre d'exemples"
                                                            min="1" :disabled="detailed_assistant.is_affected"/></div>
                              </div>
                            </div>
                          </div>
                          <div class="block mt-3">
                            <h6>Placeholders</h6>
                            <div style="max-height:220px; overflow-y:auto;">
                              <div v-if="loadingPlaceholders" class="text-muted small py-1">
                                <i class="fas fa-spinner fa-spin"></i> Chargement...
                              </div>
                              <div v-for="ph in placeholders" :key="ph.key"
                                   class="d-flex align-items-start py-1"
                                   style="gap:8px; border-bottom:1px solid #f0f0f0;">
                                <code class="text-primary"
                                      style="cursor:pointer; white-space:nowrap; font-size:0.82em;"
                                      @click="copyPlaceholderKey(ph.key)"
                                      title="Cliquer pour copier">
                                  {{ wrapPlaceholder(ph.key) }}
                                  <i class="fas fa-copy ms-1" style="font-size:0.72em;"></i>
                                </code>
                                <span class="text-muted small">{{ ph.description }}</span>
                              </div>
                              <div v-if="!loadingPlaceholders && placeholders.length === 0" class="text-muted small mt-1">
                                Aucun placeholder.
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="block">
                <div class="level">
                  <div class="level-left">
                    <button class="btn btn-primary" :disabled="detailed_assistant.is_affected" @click="add_step">+
                      Ajouter
                      un step
                    </button>
                  </div>
                  <div class="level-right">
                    <button class="btn btn-danger"
                            v-if="detailed_assistant.step_set && detailed_assistant.step_set.length &gt; 1"
                            @click="delete_last_step" :disabled="detailed_assistant.is_affected">Supprimer le dernier
                      step
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="column is-9" v-if="(batch_simulation_mode)">
          <div class="columns">
            <div class="column is-3 content_area">
              <div class="columns is-multiline is-centered">
                <div class="column is-12">
                  <button class="btn btn-primary" :class="{ 'is-clicked': show_select_review }"
                          @click="show_select_review = true">Choisir un avis
                  </button>
                </div>
                <div class="column content_area is-12" v-if="current_simulation_data.text">
                  <div class="box p-3">
                    <div class="block content">
                      <h5>Avis</h5>
                      <div class="block"><textarea class="textarea" v-model="current_simulation_data.text"
                                                   style="padding-bottom: 0px;" :disabled="true"></textarea></div>
                    </div>
                    <div class="block content" v-if="current_simulation_data.answer">
                      <h5>Réponse</h5>
                      <div class="block"><textarea class="textarea" v-model="current_simulation_data.answer"
                                                   style="padding-bottom: 0px;" :disabled="true"></textarea></div>
                    </div>
                    <div class="block content" v-else="v-else">
                      <p>Pas de réponse à cet avis</p>
                    </div>
                    <div class="block content">
                      <button class="btn btn-primary is-fullwidth" @click="launch_simulation"
                              :disabled="current_simulation_data.review_uid && current_simulation_data.review_uid.length == 0">
                        Générer
                      </button>
                    </div>
                  </div>
                </div>
                <div class="column content_area is-12 content" v-else="v-else">
                  <h5>Veuillez choisir un avis</h5>
                </div>
              </div>
            </div>
            <div class="column is-9 content_area">
              <div class="columns is-multiline">
                <div class="column content_area is-6" v-for="assistant in current_simulation_data.assistants_list">
                  <div class="box p-3">
                    <div class="block content">
                      <h4>{{ assistant.name }}</h4>
                    </div>
                    <div class="block" v-if="assistant.is_loading">
                      <div class="icon"><i class="fas fa-spinner fa-spin"></i></div>
                    </div>
                    <div class="block" v-else="v-else">
                      <div class="block" v-if="assistant.simulation_error">
                        <div class="block content">
                          <p>Il y a eu une erreur lors de la génération de la réponse. Ci-dessous le texte de
                            l'erreur.</p><textarea
                            class="textarea">{{assistant.simulation_error.bodyText}}</textarea><textarea
                            class="textarea">{{assistant.simulation_error.statusText}}</textarea>
                        </div>
                      </div>
                      <div class="block" v-else="v-else">
                        <div class="block content"><textarea class="textarea" v-if="assistant.has_been_generated"
                                                             v-model="assistant.steps_simulations[assistant.steps_simulations.length - 1].answer"
                                                             style="padding-bottom: 0px;" :disabled="true"
                                                             placeholder="Réponse générée"></textarea></div>
                        <div class="block content" v-if="assistant.has_been_generated">
                          <div class="tags"><span class="tag">Coût estimé: {{ assistant.estimated_cost }}€</span></div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="modal" v-if="show_affect_modal">
        <div class="modal-background" @click="show_affect_modal = false"></div>
        <div class="modal-card" style="width: 40%; height: 90%;">
          <div class="modal-card-head">
            <p class="modal-card-title">Affecter {{ detailed_assistant.name }}</p>
            <button class="delete" @click="show_affect_modal = false"></button>
          </div>
          <div class="modal-card-body">
            <div class="content"
                 v-if="detailed_assistant && detailed_assistant.step_set && detailed_assistant.step_set.length > 0">
              <div class="tags">
                <span class="tag">{{ detailed_assistant.step_set[0].llm_name }}</span>
                <span class="tag" v-if="detailed_assistant.created_by">
      créé par {{ detailed_assistant.created_by.username }}
    </span>
              </div>
            </div>
            <div class="field">
              <div class="btn-group">
                <button class="btn btn-info" @click="select_all_establishments">Affecter à tous les établissements
                </button>
                <button class="btn btn-outline-primary" @click="unselect_all_establishments">Affecter à aucun</button>
              </div>
            </div>
            <div class="field">
              <div class="control">
                <div class="form-check" v-for="establishment in establishments" :key="establishment.uid"><input
                    class="form-check-input" type="checkbox" :value="establishment.uid"
                    v-model="selected_establishments"/><label class="form-check-label">&nbsp;{{
                    establishment.name
                  }}</label></div>
              </div>
            </div>
          </div>
          <div class="modal-card-foot">
            <button class="btn btn-primary me-2" @click="confirm_affectation">Enregistrer</button>
            <button class="btn btn-outline-primary" @click="show_affect_modal = false">Annuler</button>
          </div>
        </div>
      </div>
      <ModalSelectReviewForSimulation v-if="show_select_review" @close="show_select_review=false"
                                      @select_review="select_review_for_simulation"></ModalSelectReviewForSimulation>
      <ModalLaboError v-if="showModalLaboError" :title="errorTitle" :message="errorMessage"
                      :stacktrace="errorStacktrace"
                      @close-modal="showModalLaboError=false"></ModalLaboError>
    </div>
  </div>
</template>
<script>
import settings from "@/settings.coffee";
import REVIEW_MESSAGE_AND_ANSWER from '@/gql/queries/reviewMessageAndAnswer.graphql';
import ESTABLISHMENT_SET from '@/gql/queries/establishmentSet.graphql';
import AVAILABLE_LLMS from '@/gql/queries/availableLlms.graphql';
import PLATFORM_SET from '@/gql/queries/platformSet.graphql';
import DEFAULT_PROMPT from '@/gql/queries/defaultPrompt.graphql';
import ALL_TAGS from '@/gql/queries/allTags.graphql';
import ASSISTANT_STEP_MUTATION from '@/gql/mutations/assistantStepMutation.graphql';
import AFFECT_ASSISTANT from '@/gql/mutations/affectAssistant.graphql';
import ASSISTANT_ACTIVE_STATUS from '@/gql/mutations/assistantActiveStatus.graphql';
import ASSISTANT from '@/gql/queries/assistants.graphql'
import PLACEHOLDER from '@/gql/queries/placeholder.graphql'
import { gqlQuery, gqlMutation } from '@/gqlClient.js';
import "bulma-switch";
import ModalSelectReviewForSimulation from "@/components/ModalSelectReviewForSimulation";
import ModalLaboError from "@/components/ModalLaboError.vue"

export default {
  name: "AssistantSetup",
  props: {
    selected_assistant_uid: String,
  },
  components: {
    ModalSelectReviewForSimulation,
    ModalLaboError
  },
  data() {
    return {
      loading: true,
      tags_set: [],
      errorTitle: "",
      errorMessage: "",
      errorStacktrace: "",
      showModalLaboError: false,
      current_simulation_data: {
        review_uid: "",
        text: "",
        answer: "",
        assistants_list: [
          {
            "steps_simulations": [
              {
                "estimated_cost": 0,
                "step_index": 0,
                "prompt": "Prompt final",
                "answer": "Réponse du step 1",
                "simulation_open": true,
              },
            ],
            "is_loading": false,
            "has_been_generated": false,
            "estimated_cost": 0
          }
        ],
      },
      // current_simulation_data: {},
      selected_assistants_uids_list: [],
      batch_simulation_mode: false,
      assistants_filters: {
        tag: {name: null, code: null},
        dateBegin: null,
        dateEnd: null,
        search_string: "",
        classified: false,
        establishment: {name: null, uid: null},
        sentiment: {name: null, value: null},
        platform: {name: null, uid: null},
        status: {name: null, uid: null},
        tags: [],
      },
      fetching_assistants: false,
      show_select_review: false,
      show_review_simulation: false,
      simulation_mode: false,
      pad_height: window.innerHeight - 105 + "px",
      show_affect_modal: false,
      assistant_creation_mode: false,
      assistant_detail_mode: false,
      assistants: [],
      available_llms: [],
      default_assistant: null,
      default_prompt: "",
      detailed_assistant: null,
      errors: {},
      establishment_set: [],
      establishments: [],
      selected_establishments: [],
      platforms_list: [],
      searchQuery: "",
      event_source: null,
      placeholders: [],
      loadingPlaceholders: false,

    };
  },
  mounted() {
  },
  async created() {
    if (this.event_source) {
      this.event_source.close();
    }
    await this.fetch_data();
    this.loading = false;

    if (Array.isArray(this.selected_assistant_uid) && this.available_llms.length > 0) {
      await this.select_assistant(this.selected_assistant_uid);
    } else if (this.selected_assistant_uid) {
      this.$nextTick(() => {
        setTimeout(() => {
          this.select_assistant(this.selected_assistant_uid);
        }, 100);
      });
    }

  },
  watch: {
    'detailed_assistant.tags': {
      deep: true,
      handler() {
        this.placeholders = []
        this.fetchPlaceholders()
      }
    }
  },
  computed: {
    filteredAssistants() {
      return this.assistants.filter((assistant) =>
          assistant.name.toLowerCase().includes(this.searchQuery.toLowerCase())
      );
    },
  },
  methods: {
    async launch_simulation() {
      self = this
      for (const assistant of this.current_simulation_data.assistants_list) {
        var generate_simultation_view_url = `${settings.backendUrl}/admin/game/generate_answer/?assistant_id=${assistant.uid}&review_id=${this.current_simulation_data.review_uid}`;

        assistant.is_loading = true
        assistant.has_been_generated = false
        assistant.simulation_error = null
        this.$http.get(generate_simultation_view_url).then((data) => {
          assistant.steps_simulations = data.data.steps_simulations;
          assistant.estimated_cost = assistant.steps_simulations.reduce((sum, item) => sum + item.estimated_cost, 0);
          assistant.total_tokens = assistant.steps_simulations.reduce((sum, item) => sum + item.nb_tokens, 0);
          assistant.is_loading = false
          assistant.has_been_generated = true
          return data;
        })
            .catch((error) => {
              assistant.steps_simulations = []
              assistant.is_loading = false
              assistant.has_been_generated = false
              assistant.simulation_error = error
              console.error("Request failed:", error);
              self.errorTitle = error.body.error.title
              self.errorStacktrace = error.body.error.stacktrace
              self.errorMessage = error.body.error.message
              self.showModalLaboError = true
            });
      }

    },
    toggle_simulation_mode() {
      this.simulation_mode = !this.simulation_mode;
    },
    add_step() {
      if (!this.detailed_assistant || !Array.isArray(this.detailed_assistant.step_set)) {
        console.warn("Impossible d’ajouter un step : detailed_assistant ou step_set est vide.");
        return;
      }

      // Fermer tous les steps existants
      this.detailed_assistant.step_set.forEach((element) => {
        element.open = false;
      });

      // Si default_assistant est défini avec un step, l'utiliser
      if (this.default_assistant && Array.isArray(this.default_assistant.step_set) && this.default_assistant.step_set.length > 0) {
        this.detailed_assistant.step_set.push({...this.default_assistant.step_set[0]});
      } else {
        // Sinon créer un step vide par défaut
        this.detailed_assistant.step_set.push({
          prompt: "",
          llm_name: "",
          temperature: 1,
          max_output_tokens: 100,
          max_input_tokens: 100,
          open: true,
        });
      }
    },
    delete_last_step() {
      this.detailed_assistant.step_set.pop();
    },
    async fetchPlaceholders() {
      const tag = this.detailed_assistant &&
        this.detailed_assistant.tags &&
        this.detailed_assistant.tags[0]
        ? this.detailed_assistant.tags[0].name
        : null
      if (!tag) return
      this.loadingPlaceholders = true
      this.placeholders = []
      const res = await gqlQuery(PLACEHOLDER, { tag })
      this.placeholders = res.body.data.placeholders || []
      this.loadingPlaceholders = false
    },
    wrapPlaceholder(key) {
      return '{{' + key + '}}'
    },
    copyPlaceholderKey(key) {
      const value = '{{' + key + '}}'
      navigator.clipboard.writeText(value).then(() => {
        this.$store.dispatch('notify', { level: 'success', text: 'Copié : ' + value, seconds: 2 })
      })
    },
    toggle_review_simulation() {
      this.show_review_simulation = !this.show_review_simulation
    },
    toggle_step_settings(index) {
      this.detailed_assistant.current_open_step_index = index
      this.$set(this.detailed_assistant.step_set, index, {
        ...this.detailed_assistant.step_set[index],
        open: !this.detailed_assistant.step_set[index].open,
      });
      this.detailed_assistant.step_set.forEach((element, i) => {
        if (i !== this.detailed_assistant.current_open_step_index) {
          this.$set(this.detailed_assistant.step_set, i, {
            ...element,
            open: false,
          });
        } else {
          this.fill_step_default_values(element.llm_name);
        }
      });
    },
    toggle_step_simulation(index) {
      this.$set(this.current_simulation_data.assistants_list[0].steps_simulations, index, {
        ...this.current_simulation_data.assistants_list[0].steps_simulations[index],
        simulation_open: !this.current_simulation_data.assistants_list[0].steps_simulations[index].simulation_open,
      });
    },
    toggle_step_prompt_simulation(index) {
      this.$set(this.current_simulation_data.assistants_list[0].steps_simulations, index, {
        ...this.current_simulation_data.assistants_list[0].steps_simulations[index],
        simulation_prompt_open: !this.current_simulation_data.assistants_list[0].steps_simulations[index].simulation_prompt_open,
      });
    },
    async select_review_for_simulation(uid) {
      this.show_select_review = false;

      // Close any existing EventSource instance
      if (this.eventSource) {
        this.eventSource.close();
      }
      const resp = await gqlQuery(REVIEW_MESSAGE_AND_ANSWER, { uid });
      var review_detail = resp.body.data.review_details;

      // Handle connection open
      this.current_simulation_data.text = review_detail.message_text;
      this.current_simulation_data.answer = review_detail.answer_text;
      this.current_simulation_data.review_uid = uid;
    },
    duplicate_current() {
      this.assistant_creation_mode = true;
      this.simulation_mode = false;
      this.assistant_detail_mode = false;
      this.detailed_assistant.name = "";
      this.detailed_assistant.uid = "";
      this.detailed_assistant.is_affected = false;
      this.detailed_assistant.is_active = false;
      this.selected_assistants_uids_list = [];
    },
    async fetch_data() {
      this.fetching_assistants = true;
      try {
        const [respAssistants, respLlms, respPlatforms, respPrompt, respTags] = await Promise.all([
          gqlQuery(ASSISTANT, {ignore_tag: true}),
          gqlQuery(AVAILABLE_LLMS, {}),
          gqlQuery(PLATFORM_SET, {}),
          gqlQuery(DEFAULT_PROMPT, {}),
          gqlQuery(ALL_TAGS, {}),
        ]);
        this.assistants = respAssistants.body.data.assistants;
        this.assistants.map((assistant) => {
          if (assistant.step_set[0].example_fixed_n === null) {
            assistant.step_set[0].example_fixed_n = 0;
          }
        });
        this.sortBy(this.assistants, "created_on");
        this.available_llms = respLlms.body.data.available_llms;
        this.platforms_list = respPlatforms.body.data.platform_set;
        this.tags_set = respTags.body.data.all_tags;
        const respEstabs = await gqlQuery(ESTABLISHMENT_SET, { active: true });
        this.establishments = respEstabs.body.data.establishment_set || [];
        this.establishment_set = this.establishments;
        this.default_assistant = {
          uid: "",
          name: "",
          is_active: true,
          specialist_sentiment: "",
          specialist_platform_id: null,
          elo_global: null,
          is_affected: false,
          current_open_step_index: 0,
          step_set: [
            {
              uid: "",
              open: true,
              llm_name: "",
              temperature: 0.8,
              max_output_tokens: 0,
              max_input_tokens: 0,
              input_cost_per_token: 0,
              output_cost_per_token: 0,
              supported_openai_params: "",
              provider: "",
              search_examples: true,
              example_choice_strategy: "random",
              example_selection_strategy: "pre_selection",
              example_fill_strategy: "fill_context",
              example_fixed_n: 0,
              prompt: respPrompt.body.data.default_prompt.prompt,
            },
          ],
          tags: [],
          affectation_set: [],
        };
        this.fetching_assistants = false;
      } catch (error) {
        console.error("Error fetching data:", error);
        this.fetching_assistants = false;
      }
    },
    getAssistantCardTagClass(assistant) {
      var result = [];
      if (assistant.elo_score) {
        result.push("is-primary");
      } else {
        result.push("is-warning");
      }
      return result;
    },
    getAssistantCardClass(assistant) {
      var result = ["is-clickable"];
      if (
          this.detailed_assistant != null &&
          assistant.name === this.detailed_assistant.name
      ) {
        result.push("assistant-selected");
      } else if (this.selected_assistants_uids_list.includes(assistant.uid)) {
        result.push("assistant-selected");
      }
      if (!assistant.is_active) {
        result.push("has-background-grey-light");
      } else if (assistant.is_affected) {
        result.push("has-background-success-light");
      } else {
        result.push("has-background-warning-light");
      }
      assistant.selected = this.is_assistant_selected(assistant);
      return result;
    },
    is_assistant_selected(assistant) {
      var res = this.selected_assistants_uids_list.includes(assistant.uid);
      return res;
    },
    fill_step_default_values(llm_name) {
      if (!llm_name || !Array.isArray(this.available_llms) || this.available_llms.length === 0) {
        console.warn("fill_step_default_values : llm_name invalide ou modèles pas encore chargés.");
        return;
      }

      const model_info = this.available_llms.find((model) => model.name === llm_name);
      if (!model_info) {
        console.warn(`Modèle introuvable : ${llm_name}`);
        return;
      }

      const step = this.detailed_assistant.step_set[this.detailed_assistant.current_open_step_index];
      if (!step) {
        console.warn("Step courant non défini");
        return;
      }

      this.$set(step, "max_input_tokens", model_info.max_input_tokens);
      this.$set(step, "max_output_tokens", model_info.max_output_tokens);
      this.$set(step, "max_tokens", model_info.max_input_tokens + model_info.max_output_tokens);
      this.$set(step, "input_cost_per_token", model_info.input_cost_per_token);
      this.$set(step, "output_cost_per_token", model_info.output_cost_per_token);
      this.$set(step, "mode", model_info.mode);
      this.$set(step, "supported_openai_params", model_info.supported_openai_params);
      this.$set(step, "provider", model_info.litellm_provider);
    },
    fill_model_info(llm_name) {
      var model_info = this.available_llms.find((model) => model.name == llm_name);
      if (model_info) {
        this.$set(
            this.detailed_assistant,
            "input_cost_per_token",
            model_info.input_cost_per_token
        );
        this.$set(
            this.detailed_assistant,
            "output_cost_per_token",
            model_info.output_cost_per_token
        );
        this.$set(this.detailed_assistant, "mode", model_info.mode);
        this.$set(
            this.detailed_assistant,
            "supported_openai_params",
            model_info.supported_openai_params
        );
        this.$set(this.detailed_assistant, "provider", model_info.litellm_provider);
        this.$set(
            this.detailed_assistant,
            "max_tokens",
            model_info.max_input_tokens + model_info.max_output_tokens
        );
        this.$set(
            this.detailed_assistant,
            "max_input_tokens",
            model_info.max_input_tokens
        );
        this.$set(
            this.detailed_assistant,
            "max_output_tokens",
            model_info.max_output_tokens
        );
        this.$set(
            this.detailed_assistant.step_set[0],
            "max_input_tokens",
            model_info.max_input_tokens
        );
        this.$set(
            this.detailed_assistant.step_set[0],
            "max_tokens",
            model_info.max_input_tokens + model_info.max_output_tokens
        );

      }
    },
    async update_right_pannel() {
      if (this.selected_assistants_uids_list.length == 1) {
        this.current_simulation_data.assistants_list = []
        const resp = await gqlQuery(ASSISTANT, {
          uid: this.selected_assistants_uids_list[0],
          ignore_tag: true,
        })
        this.detailed_assistant = resp.body.data.assistants[0];
        if (!this.detailed_assistant) return;
        this.detailed_assistant.step_set.forEach((element) => {
          element.open = false;
        });
        this.sortBy(this.detailed_assistant.step_set, "step_index");
        if (this.detailed_assistant.step_set[0]) {
          this.detailed_assistant.step_set[0].open = true;
        }
        this.detailed_assistant.current_open_step_index = 0
        this.fill_step_default_values(this.detailed_assistant.step_set[0].llm_name);
        this.selected_establishments = this.detailed_assistant.affectation_set.map(
            (item) => item.establishment.uid
        );
        this.assistant_creation_mode = false;
        this.assistant_detail_mode = true;
        // set this manually
        if (this.detailed_assistant.specialist_platform) {
          this.detailed_assistant.specialist_platform_id = this.detailed_assistant.specialist_platform.uid
        } else {
          this.detailed_assistant.specialist_platform_id = "null"
        }

        this.batch_simulation_mode = false;
      } else if (this.selected_assistants_uids_list.length > 1) {
        this.current_simulation_data.assistants_list = []

        this.assistant_detail_mode = false;
        this.batch_simulation_mode = true;
        this.detailed_assistant = null;
      } else if (this.selected_assistants_uids_list.length == 0) {
        this.current_simulation_data.assistants_list = []

        this.detailed_assistant = null;
        this.batch_simulation_mode = false;
        this.assistant_creation_mode = false;
        this.assistant_detail_mode = false;
      }
      this.assistants.forEach((element) => {
        if (this.selected_assistants_uids_list.includes(element.uid)) {
          this.current_simulation_data.assistants_list.push({
            uid: element.uid,
            name: element.name,
            steps_simulations: [
              {
                estimated_cost: 0,
                step_index: 0,
                prompt: "Prompt final",
                answer: "Réponse du step 1",
                simulation_open: true,
                simulation_prompt_open: false,
              },
            ],
            is_loading: false,
            has_been_generated: false
          });
        }
      });
      this.current_simulation_data.assistants_list = this.current_simulation_data.assistants_list.filter(
          (item, index, self) => index === self.findIndex((a) => a.uid === item.uid)
      );
    },

    unselect_assistant_uid(assistant_uid) {
      const index = this.selected_assistants_uids_list.indexOf(assistant_uid);
      this.selected_assistants_uids_list.splice(index, 1); // 2nd parameter means remove one item only
    },
    async select_assistant(assistant_uid) {
      if (this.selected_assistants_uids_list.includes(assistant_uid)) {
        this.unselect_assistant_uid(assistant_uid);
      } else {
        this.selected_assistants_uids_list = [assistant_uid];
      }
      this.update_right_pannel();
    },
    async assistant_multi_select(event, assistant_uid) {
      event.stopPropagation();

      if (this.selected_assistants_uids_list.includes(assistant_uid)) {
        this.unselect_assistant_uid(assistant_uid);
      } else {
        this.selected_assistants_uids_list.push(assistant_uid);
      }
      this.update_right_pannel();
    },
    llm_selected(event) {
      const current_value = event.target.value;
      this.fill_step_default_values(current_value);
    },
    validate_form() {
      this.detailed_assistant.step_set.forEach((step) => {
        step.max_output_tokens = Number(step.max_output_tokens);
        step.max_input_tokens = Number(step.max_input_tokens);
        this.errors = {};
        if (!step.prompt) {
          this.errors.prompt = "Le prompt est requis";
        }
        if (!step.llm_name) {
          this.errors.llm_name = "Le modèle est requis";
        }
        if (step.max_output_tokens > this.detailed_assistant.max_output_tokens) {
          this.errors.max_tokens =
              "Le nombre de token output est trop élevé pour ce modèle";
        }
        if (step.max_input_tokens > this.detailed_assistant.max_input_tokens) {
          this.errors.max_tokens =
              "Le nombre de token input est trop élevé pour ce modèle";
        }
      });

      const filtered_array = this.assistants.filter(
          (assistant) => assistant.name === this.detailed_assistant.name
      );
      if (!this.detailed_assistant.name) {
        this.errors.name = "Le nom est requis";
      } else if (this.assistant_creation_mode && filtered_array.length > 0) {
        this.errors.name = "Le nom est déjà pris par un assistant existant";
      }
      return Object.keys(this.errors).length === 0;
    },
    async save_assistant() {
      if (this.validate_form()) {
        const step_set = this.detailed_assistant.step_set.map(s => ({
          llm_name: s.llm_name,
          temperature: s.temperature,
          max_input_tokens: s.max_input_tokens,
          max_output_tokens: s.max_output_tokens,
          search_examples: s.search_examples,
          example_choice_strategy: s.example_choice_strategy,
          example_selection_strategy: s.example_selection_strategy,
          example_fill_strategy: s.example_fill_strategy,
          example_fixed_n: s.example_fixed_n,
          encoded_prompt: btoa(unescape(encodeURIComponent(s.prompt || ''))),
        }));
        const resp = await gqlMutation(ASSISTANT_STEP_MUTATION, {
          uid: this.detailed_assistant.uid,
          name: this.detailed_assistant.name,
          step_set,
          specialist_platform_id: this.detailed_assistant.specialist_platform_id,
          specialist_sentiment: this.detailed_assistant.specialist_sentiment,
          is_active: this.detailed_assistant.is_active,
          tags: (this.detailed_assistant.tags || []).map(t => String(t.id)),
        });
        this.assistant_creation_mode = false;
        this.assistant_detail_mode = true;
        await this.fetch_data();
        this.$store.dispatch("notify", { level: "success", text: "Assistant sauvegardé !", seconds: 4 });
      } else {
        console.error("Validation failed", this.errors);
        this.$store.dispatch("notify", { level: "danger", text: "Veuillez corriger les erreurs du formulaire.", seconds: 4 });
      }
    },
    async affect_assistant(establishment_uids) {
      try {
        await gqlMutation(AFFECT_ASSISTANT, {
          assistant_uid: this.detailed_assistant.uid,
          establishment_uids: [...establishment_uids],
        });
        this.show_affect_modal = false;
        this.fetch_data();
      } catch (error) {
        console.error("Error affecting assistant:", error);
      }
    },
    async change_activation_status() {
      var is_active_new_status = !this.detailed_assistant.is_active;
      try {
        await gqlMutation(ASSISTANT_ACTIVE_STATUS, {
          name: this.detailed_assistant.name,
          uid: this.detailed_assistant.uid,
          is_active: is_active_new_status,
        });
        this.show_affect_modal = false;
        this.fetch_data();
      } catch (error) {
        console.error("Error updating assistant active status assistant:", error);
      }
    },
    select_all_establishments() {
      this.selected_establishments = this.establishments.map(
          (establishment) => establishment.uid
      );
    },
    unselect_all_establishments() {
      this.selected_establishments = [];
    },
    confirm_affectation() {
      this.affect_assistant(this.selected_establishments);
      this.show_affect_modal = false;
      this.$store.dispatch("notify", { level: "success", text: "Affectation sauvegardée !", seconds: 4 });
    },
    sortBy(array, property) {
      array.sort((a, b) => {
        if (a[property] > b[property]) {
          return 1;
        } else if (a[property] < b[property]) {
          return -1;
        }
        return 0;
      });
    },
  },
};
</script>

<style scoped>
.columns {
  display: flex;
}

.column.is-2 {
  border-right: 1px solid #ddd;
  padding-right: 1rem;
}

.column.is-10 {
  padding-left: 1rem;
}

.is-clicked {
  background-color: #7777ff;
}

.error {
  color: red;
  font-size: 0.9em;
  margin-top: 0.25rem;
}

.modal {
  display: flex;
  align-items: center;
  justify-content: center;
}

.modal-card {
  max-width: 90%;
}

/* Classes pour les couleurs des cartes */
.has-background-grey-light {
  --bg-color: #bfbfbf;
  background-color: #bfbfbf;
}

.has-background-success-light {
  --bg-color: #d4edda;
  background-color: #d4edda;
}

.has-background-warning-light {
  --bg-color: #fff3cd;
  background-color: #fff3cd;
}

.assistant-selected {
  border: 2px solid #222;
}
</style>
